import client from "api/client";
import BaseApiResponseModel from "api/model/BaseApiResponseModel";
import ApiPath from "../ApiPath";
import { LoginRequestModel } from "./model/LoginRequestModel";
import LoginResponseModel from "./model/LoginResponseModel";

//login
const login = async (
  props: LoginRequestModel,
): Promise<BaseApiResponseModel<LoginResponseModel>> => {
  return await client.post(ApiPath.LOGIN, props);
};

const forgetPassword = async (
  props: any,
): Promise<BaseApiResponseModel<any>> => {
  return await client.post(ApiPath.FORGOTPASSWORD, props);
};

const verifyOtp = async (props: any): Promise<BaseApiResponseModel<any>> => {
  return await client.post(ApiPath.VERIFYOTP, props);
};

const resetPassword = async (
  props: any,
): Promise<BaseApiResponseModel<any>> => {
  return await client.post(ApiPath.RESETPASSWORD, props);
};

const changePassword = async (
  props: any,
): Promise<BaseApiResponseModel<any>> => {
  return await client.post(ApiPath.CHANGEPASS, props);
};

export default {
  login,
  forgetPassword,
  verifyOtp,
  resetPassword,
  changePassword,
};
